"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Main = ({ sidebarVisible, children }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `flex-1 min-h-0 transition-all duration-300 h-full mt-16 ${sidebarVisible ? 'ml-[20rem]' : 'ml-0'}`, children: children }));
};
exports.Main = Main;
